import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//connect local locales
import enLocales from './en.json';
import dkLocales from './dk.json';
import noLocales from './no.json';
import svLocales from './sv.json';
import deLocales from './de.json';
import fiLocales from './fi.json';
//gsg shared/external locales
import {
  enGsgUiTranslations as enExternal,
  dkGsgUiTranslations as dkExternal,
  noGsgUiTranslations as noExternal,
  svGsgUiTranslations as svnExternal,
  fiGsgUiTranslations as fiExternal,
  deGsgUiTranslations as deExternal

} from '@gsgroup/gsgroup-react-ui';

// ----------------------------------------------------------------------
const merge = (app: object, lib: object) => ({ ...lib, ...app });

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: merge(enLocales, enExternal) },
      dk: { translations: merge(dkLocales, dkExternal) },
      no: { translations: merge(noLocales, noExternal) },
      sv: { translations: merge(svLocales, svnExternal) },
      de: { translations: merge(deLocales, deExternal) },
      fi: { translations: merge(fiLocales, fiExternal) }
    },
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
